import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrainingComponent } from './components/training/training.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { SettingsComponent } from './settings.component';

const routes: Routes = [
  { path: '', component: SettingsComponent },
  { path: 'profile', component: UserProfileComponent },
  { path: 'training', component: TrainingComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  providers: []
})
export class SettingsRoutingModule { }
